// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_fit-guide.scss';


// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}


$(function() {
    // -------------------------------------
    // Fit Guide Carousel
    // -------------------------------------
    $(".carousel--collection-fit-guide").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("collection-fit-guide-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.fit-guide-cards').find(".swiper-button-prev").addClass("collection-fit-cards-btn-prev-" + index);
        $this.parents('.fit-guide-cards').find(".swiper-button-next").addClass("collection-fit-cards-btn-next-" + index);

        // Generate unique btn classes for slider swiper
        $this.parents('.fit-guide-cards').find(".swiper-scrollbar").addClass("collection-fit-cards-swiper-scrollbar-" + index);


        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".collection-fit-guide-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 2.2,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            a11y: false,
            initialSlide: 0,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            keyboard: {
                enabled: false
            },

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 4,
                    spaceBetween: 10
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 18
                }
            },

             // // Navigation arrows
            navigation: {
                nextEl: ".collection-fit-cards-btn-next-" + index,
                prevEl: ".collection-fit-cards-btn-prev-" + index
            },

            // // Navigation scrollbar
            scrollbar: {
                el: ".collection-fit-cards-swiper-scrollbar-" + index,
                draggable: true,
            }
        });
    });
});


$(function() {
    // -------------------------------------
    // Fit Guide Carousel
    // -------------------------------------
    $(".fit-cards__info-container").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("fit-cards__info-container-" + index);

        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".fit-cards__info-container-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 1.7,
            spaceBetween: 12,
            observer: true,
            observeParents: true,
            a11y: false,
            initialSlide: 0,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            keyboard: {
                enabled: false
            },

            breakpoints: {
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 15
                }
            }
        });
    });
});

// -------------------------------------
// Variables
// -------------------------------------

const TAB_BUTTON_DESKTOP    = '.page-section--fit-guide .js-tab__button--desktop';
const TAB_CONTENT_DESKTOP   = '.page-section--fit-guide .js-tab__content--desktop';
const TABS_CONTAINER        = '.js-tabs--desktop';

// Constant trigger classes
const OPEN_CLASS            = 'is-open';

// Button Group
const BUTTON_GROUP_DESKTOP  = $(TAB_BUTTON_DESKTOP);


// -------------------------------------
// Helper Functions
// -------------------------------------

function tabOpen(tab) {
    const tab_id = tab[0].id;
    const tab_data = tab_id.replace("--button", "");
    const tab_conent_id = tab_data + "--content";
    const tab_content = $("#" + tab_conent_id);

    if (!tab.hasClass(OPEN_CLASS)) {
        // Close all other Panels
        tab.siblings().find(TAB_BUTTON_DESKTOP).attr("tabindex", "-1");
        tab.siblings().removeClass(OPEN_CLASS);
        tab_content.siblings().removeClass(OPEN_CLASS);
        tab_content.siblings().css("opacity", "0");
        tab_content.siblings().attr('hidden', true).animate({"max-height": 0, opacity: '0%'}, 1000)
        // tab_content.fadeTo("1000", 0);

        // Toggle new panel
        tab.addClass(OPEN_CLASS);
        tab.attr("tabindex", null);
        tab_content.attr('hidden', false);
        tab_content.animate({"max-height": 1000, opacity: '100%'}, 1000).attr('hidden', false).addClass(OPEN_CLASS)

        } else {
            tab.toggleClass(OPEN_CLASS);
            tab_content.attr('hidden', true).removeClass(OPEN_CLASS);
        }
    }



// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {
    // Card opens Panel
    try {
        tabOpen($(TAB_BUTTON_DESKTOP).first())
    }
    catch(error) {
        console.log(error);
    }
    $(TAB_BUTTON_DESKTOP).on('click keydown', function(e) {
        if (e.type === 'click') {
            e.preventDefault();
            tabOpen($(this));
        }
        else if (e.type === 'keydown') {
            let key = e.which.toString();
            if (key.match(/35|36|37|39/)) {
                e.preventDefault();
                let index = $.inArray(e.target, BUTTON_GROUP_DESKTOP);
                let length = BUTTON_GROUP_DESKTOP.length;
                let newIndex;
                switch(key) {
                    case '37': // Up
                        newIndex = (index + length + -1) % length;
                        BUTTON_GROUP_DESKTOP[newIndex].focus();
                        tabOpen($(BUTTON_GROUP_DESKTOP[newIndex]));
                        break;
                    case '39': // Down
                        newIndex = (index + length + 1) % length;
                        BUTTON_GROUP_DESKTOP[newIndex].focus();
                        tabOpen($(BUTTON_GROUP_DESKTOP[newIndex]));
                        break;
                    case '35': // End
                        BUTTON_GROUP_DESKTOP[length - 1].focus();
                        tabOpen($(BUTTON_GROUP_DESKTOP[length - 1]));
                        break;
                    case '36': // Home
                        BUTTON_GROUP_DESKTOP[0].focus();
                        tabOpen($(BUTTON_GROUP_DESKTOP[0]));
                        break;
                }
            } else {
                return true;
            }
        }
    });
});